import React from 'react'
import Menu from '../Menu/Menu'
import './profileLeft.css'

const ProfileLeft = () => {
  return (
    <div className='ProfileLeft'>
      <Menu />
    </div>
  )
}

export default ProfileLeft